import {compose} from 'redux';
import {connect} from 'react-redux';

import {type RootState} from 'web-app/react/redux/root-state';
import * as ModalsContainerSelectors from 'web-app/react/modals-container/selectors';

import * as Actions from './actions';
import GlobalEventContent from './global-event-content';
import {type StateProps} from './types';

const mapDispatchToProps = () => ({
    clearStatus: eventId => Actions.clearStatus.dispatch(eventId),
});

export default compose(
    connect(
        (state: RootState): StateProps => ({
            events: state.globalEvent.events,
            isShowingModals: ModalsContainerSelectors.isShowingModals(state),
        }),
        mapDispatchToProps,
    ),
)(GlobalEventContent);
